import { $api } from '@service/RequestService';
import { queryNames } from '@utils/constants/queryNames';
import { LeadEventsAndTasksList } from '@utils/models/LeadEventsAndTaskList';
import { useMutation, useQueryClient } from 'react-query';

export const useCallSummaryRateSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async ({
      leadId,
      noteId,
      ...data
    }: {
      id: number;
      rate: boolean;
      feedback?: string;
      leadId?: number;
      noteId?: number;
    }) => {
      qc.setQueryData<LeadEventsAndTasksList[]>([queryNames.LEAD_COMPLETED_DATA, leadId], prev =>
        (prev || [])?.map(item => ({
          ...item,
          events: item?.events?.map(event => ({
            ...event,
            res: {
              ...event?.res,
              callAnalyse:
                noteId === event?.res?.id
                  ? {
                      ...event?.res?.callAnalyse,
                      dislikeSummary: !data?.rate,
                      likeSummary: data?.rate
                    }
                  : event?.res?.callAnalyse
            }
          }))
        }))
      );

      const res = await $api.post('/v1/call-summary/rate', data);

      return res?.data;
    }
  );
};
